import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private http: HttpClient) {}

  getUsers() {
    return this.http.get('/rl/api/user-management/users');
  }

  getAdminState() {
    return this.http.get('/rl/api/user-management/state');
  }

  updateCurrencyPairs(updateCommand) {
    return this.http.post('/rl/api/currency/update', updateCommand);
  }

  createCurrencyPair(updateCommand) {
    return this.http.post('/rl/api/currency/create', updateCommand);
  }

  createUser(user) {
    return this.http.post('/rl/api/user-management/create-user', user);
  }

  modifyAbosId(user) {
    return this.http.post('/rl/api/user-management/modify-abos-id', user);
  }

  changePassword(user) {
    return this.http.post('/rl/api/user-management/change-password', user);
  }

  changeEmail(user) {
    return this.http.post('/rl/api/user-management/change-email', user);
  }
}
